module.exports = __webpack_public_path__ + "static/media/stocks-8.75ae5e86.jpg";